import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    report: PropTypes.object.isRequired,
  },
  render() {
    const reportImage = this.props.report.photo_url_medium ? (
      <img src={this.props.report.photo_url_medium} />
    ) : (
      ""
    );
    return (
      <div
        className="col-xs-6 col-sm-4 col-md-4 col-lg-4 grid-item"
        style={{ paddingLeft: "5px", paddingRight: "5px" }}
      >
        <a
          href={`/event/${this.props.report.event.id}/reports/${
            this.props.report.id
          }`}
        >
          <div className="thumbnail">
            <p className="small left mt5 ml5" style={{ color: "#999" }}>
              {this.props.report.event.event_date_disp}{" "}
              {this.props.report.event.title}
            </p>
            {reportImage}
            <div className="caption">
              <h4>{this.props.report.title}</h4>
              <p>{this.props.report.description}</p>
              <p className="small right" style={{ color: "#999" }}>
                <a href={`/circle/${this.props.report.event.circle.id}`}>
                  <span className="color-main-strong">
                    {this.props.report.event.circle.name}
                  </span>
                </a>
              </p>
              <p className="small right" style={{ color: "#999" }}>
                {this.props.report.created_at_disp} {this.props.report.nickname}さん{" "}
                {this.props.report.report_type_manager_disp}
              </p>
            </div>
          </div>
        </a>
      </div>
    );
  },
});
